// Modules
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from "react-redux";

// CSS
import '_Asset/css/Admin/Page/admin.css'

// API
import { AdIncruitApi, AdIncruitListApi, AdIncruitCatApi, AdIncruitSgApi } from "_Route/Api";
import uuid from "react-uuid";
import DefaultCKEditor from "Admin/Component/DefaultCKEditor";


const AdDevEmployDt = () => {

  registerLocale('ko', ko)

  // Using Hooks
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // State
  const [guideStatus, setGuideStatus] = useState(true);
  const curType = params.id === 'add' ? '등록' : '수정'; // 관리 Type
  const curScore = params.id === 'add' ? 200 : 300;
  const useGroup = ['미사용', '사용']; // 사용 여부 배열

  const sessionID = localStorage.getItem('memSessionID')
  const userName = useSelector(state => state.authorityAcc.name)
  const userScore = useSelector(state => state.authorityAcc.access_score);
  const master = useSelector(state => state.authorityAcc.master);

  const [catList, setCatList] = useState([]);
  const [catValue, setCatValue] = useState();
  const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm'); // 현재 날짜 및 시간
  const [startDate, setStartDate] = useState('');
  const [lastDate, setLastDate] = useState('');
  
  const [info, setInfo] = useState({ // 전체 Data 배열 
    incruit_title: '',
    incruit_content: '',
    incruit_experience: '2',
    incruit_tag: '',
    incruit_start_date: '',
    incruit_last_date: '',
    incruit_create_user: userName,
    incruit_last_modify_user: userName,
    incruit_use: 1,
    approve_spec_status: 0,
    approve_ap_status: 0,
  })
  const [tagName, setTagName] = useState(''); 
  const [tagList, setTagList] = useState([]); 
  const { incruit_title, incruit_content, incruit_experience, incruit_tag, incruit_start_date, incruit_last_date, incruit_create_user, incruit_last_modify_user, incruit_use } = info;
  

  /*========================================================================
  * Input onChange Func
  ========================================================================*/
  // onChange Info
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});
  }

  // Tag 추가 Function
  const onKeyPress = (e) => { if(e.key == 'Enter') addTag(); }
  const addTag = () => {

    const tagArr = tagName.split(',');
    tagArr.map((tag, i) => {
      tagArr[i] = '#' + tag.trim()
    })
    
    if(tagArr.length + tagList.length > 5) {
      alert("태그는 최대 5개까지 입력할 수 있습니다.")
    }
    else if (tagName === '') {
      alert("태그를 입력해주세요.")
    }
    else if (tagList.includes('#' + tagName.trim()) || tagArr.filter(x => tagList.includes(x)).length > 0) {
      alert("입력한 태그명이 이미 존재합니다.")
    }
     else {
      if(tagArr.length >= 2) { // , 다중 입력 체크
        const set = new Set(tagArr);
        if (set.size < tagArr.length) { // 중복 태그가 존재하는지 체크
          alert("중복된 태그명이 존재합니다.")
        } else {
          tagArr.map(tag => { // 다중 입력 태그 저장
            setTagList(prevList => [...prevList, tag])
          })
        }
      } else { // 단일 입력 태그 저장
        setTagList(prevList => [...prevList, '#' + tagName.trim()]);
      }
      setTagName('');
    }
  }

  useEffect(() => {
    setInfo({...info, incruit_tag: tagList.length === 0 ? '' : tagList})
  }, [tagList])

  useEffect(() => {
    setInfo({
      ...info,
      incruit_start_date: moment(startDate).format('YYYY-MM-DD HH:mm'),
      incruit_last_date: moment(lastDate).format('YYYY-MM-DD HH:mm')
    })
  }, [startDate, lastDate])
  


  /*========================================================================
  * Set Current Incruit List
  ========================================================================*/
  useEffect(() => {
    axios.get(AdIncruitCatApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
    })
    .then(res => {
      setCatList(res.data.result)
    })
    .catch(err => {
      console.error(err, "GET Incruit Experience Error...");
    })

    axios.get(AdIncruitSgApi, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      params: {
        incruit_uuid: params.id
      }
    })
    .then(res => {
      const curIncruit = res.data.result[0]
      if(curIncruit === undefined && params.id !== 'add') {
        navigate('/404');
      }

      if(curType === '수정') {
        setCatValue(curIncruit.incruit_experience);
        setStartDate(new Date(curIncruit.incruit_start_date))
        setLastDate(new Date(curIncruit.incruit_last_date))

        if(curIncruit.incruit_tag.length >= 1) {
          setTagList(JSON.parse(curIncruit.incruit_tag))
        }
      }
      setInfo({
        incruit_title: curType === '수정' ? curIncruit.incruit_title : '',
        incruit_content: curType === '수정' ? curIncruit.incruit_content : '',
        incruit_experience: curType === '수정' ? curIncruit.incruit_experience : '2',
        incruit_tag: curType === '수정' ? JSON.parse(curIncruit.incruit_tag) : '',
        incruit_start_date: curType === '수정' ? moment(curIncruit.incruit_start_date).format('YYYY-MM-DD HH:mm') : '',
        incruit_last_date: curType === '수정' ? moment(curIncruit.incruit_last_date).format('YYYY-MM-DD HH:mm') : '',
        incruit_create_user: curType === '수정' ? curIncruit.incruit_create_user : userName,
        incruit_last_modify_user: userName,
        incruit_use: curType === '수정' ? curIncruit.incruit_use : 1,
        approve_spec_status: 0,
        approve_ap_status: 0,
      })
    })
    .catch(err => {
      console.error(err, "GET Incruit Data Error...");
    })
  }, [location])


  /*========================================================================
  * Incruit Axios 
  ========================================================================*/
  const IncruitConfirm = () => {
    if (incruit_tag === '' || incruit_tag.length === 0) { alert("사용할 태그를 추가해주세요.") }
    else if (incruit_title === '') { alert("제목을 입력해주세요.") }
    else if (incruit_content === '') { alert("내용을 입력해주세요.") }
    else {
      if (curType === '수정') { updateIncruit() }
      else { postIncruit() }
    }
  }
  
  const postIncruit = () => { // Incruit 등록
    axios({
      url: AdIncruitApi,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: info
    })
    .then(res => {
      alert(`채용 글 등록${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/dev-employ/incruit/list')
    })
    .catch(err => {
      // alert(err.response.data.result)
      console.error(err, `Incruit POST Error..`)
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const updateIncruit = () => { // Incruit 수정
    const tempInfo = info;
    tempInfo.incruit_uuid = params.id

    axios({
      url: AdIncruitApi,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: tempInfo
    })
    .then(res => {
      alert(`채용 글 수정${master === 1 ? '' : ' 요청'}을 완료하였습니다.`)
      navigate('/admin/dev-employ/incruit/list')
    })
    .catch(err => {
      console.error(err, "Incruit PUT Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }

  const deleteIncruit = () => { // Incruit 삭제
    axios({
      url: AdIncruitApi,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        'Authorization': sessionID,
      },
      data: {
        incruit_uuid: params.id,
        approve_spec_status: 0,
        approve_ap_status: 0,
      }
    })
    .then(res => {
      alert(`채용 글 삭제${master === 1 ? '를' : ' 요청을'} 완료하였습니다.`)
      navigate('/admin/dev-employ/incruit/list')
    })
    .catch(err => {
      console.error(err, "Incruit DELETE Error..")
      const errMsg = err.response.data.message
      if (errMsg) { alert(errMsg) }
    })
  }


  return (
    <>
      <div className="adContTitGroup">
        <h2>채용 글 {curType}</h2>
        <p>Home / 개발자 채용 / 채용 글 {curType} <button type="button" onClick={() => setGuideStatus(!guideStatus)}><i className="icofont-info-circle" /> 가이드 {guideStatus ? '접기' : '보기'} <i className={`icofont-rounded-${guideStatus ? 'up' : 'down'}`} /></button></p>

        <ul className={`subMsg ${guideStatus ? '' : 'off'}`}>
          <li>* 태그 추가시 ,로 구분하여 <span className="blueTxt">일괄 추가가 가능</span>합니다.</li>
        </ul>
      </div>

      <div className="adContArea detail">
        <fieldset className="left">
          <legend>채용 글 수정</legend>

          {/* 사용여부 [incruit_use] */}
          <div className="fieldGroup row">
            <label>사용여부<span className="redTxt">*</span></label>

            <div className="field">
              {useGroup.map((item, i) =>
                <div className="checkGroup" key={i}>
                  <input type="radio" className="check sm blue" name="incruit_use" id={`incruit_use_${i}`} value={i} onChange={(e) => onChange(e)} checked={Number(incruit_use) === i}/>
                  <label htmlFor={`incruit_use_${i}`}></label>

                  <label htmlFor={`incruit_use_${i}`}>{item}</label>
                </div>
              )}
            </div>
          </div>

          {/* 카테고리 [incruit_experience] */}
          <div className="fieldGroup row">
            <label>카테고리<span className="redTxt">*</span></label>

            <div className="field gap">
              
              <select className="select md round_10 type_1" name="incruit_experience" onChange={(e) => {onChange(e); setCatValue(e.target.value)}} key={uuid()} defaultValue={curType === '등록' ? incruit_experience : catValue}>
                {catList.map((list, i) =>
                  <option value={list.inccat_no} key={i}>{list.incruit_cat}</option>
                )}
              </select>
            </div>
          </div>

          {/* 태그 [incruit_tag] */}
          <div className="fieldGroup row">
            <label>태그<span className="redTxt">*</span></label>

            <div className="field gap">
              <input type="text" className="input md round_10" name="incruit_tag" onChange={(e) => setTagName(e.target.value)} onKeyPress={(e) => onKeyPress(e)} value={tagName} placeholder="추가할 태그를 입력해주세요." disabled={tagList.length > 4 ? true : false}/>
              <button type="button" className="btn sm round_10 sfrtBlue" onClick={() => addTag()}>태그 추가</button>
              {tagList.length > 0 &&
                <div className="tagList">
                  {tagList.map((list, i) =>
                    <p key={i}>{list}<button type="button" className="icofont-error" onClick={() => setTagList(tagList.filter((key, index) => i !== index))}></button></p>
                  )}
                </div>
              }
            </div>
          </div>

          {/* 모집기간 [incruit_start_date ~ incruit_last_date] */}
          <div className="fieldGroup row">
            <label>모집기간<span className="redTxt">*</span></label>

            <div className="field gap">
              <div className="inputIco">
                <DatePicker
                  className="input md round_10 i_rt time"
                  locale={ko}
                  showTimeSelect
                  timeIntervals={10}
                  timeCaption="Time"
                  selected={startDate}
                  onChange={date => setStartDate(date)}
                  dateFormat="yyyy.MM.dd HH:mm"
                  maxDate={new Date(lastDate)}
                  minTime={moment(startDate).format('YYYYMMDD') === moment(lastDate).format('YYYYMMDD') ? new Date().setHours(0, 0) : undefined}
                  maxTime={moment(startDate).format('YYYYMMDD') === moment(lastDate).format('YYYYMMDD') ? new Date(lastDate) : undefined}
                  placeholderText="모집 시작 시간"
                />
                <i className="icofont-calendar"></i>
              </div>

              <span>~</span>

              <div className="inputIco">
                <DatePicker
                  className="input md round_10 i_rt time"
                  locale={ko}
                  showTimeSelect
                  timeIntervals={10}
                  timeCaption="Time"
                  selected={lastDate}
                  onChange={date => setLastDate(date)} 
                  dateFormat="yyyy.MM.dd HH:mm"
                  minDate={new Date(startDate)}
                  minTime={moment(startDate).format('YYYYMMDD') === moment(lastDate).format('YYYYMMDD') ? new Date(startDate) : undefined}
                  maxTime={moment(startDate).format('YYYYMMDD') === moment(lastDate).format('YYYYMMDD') ? new Date().setHours(23, 50) : undefined}
                  placeholderText="모집 종료 시간"
                />
                <i className="icofont-calendar"></i>
              </div>
            </div>
          </div>

          {/* 제목 [incruit_title] */}
          <div className="fieldGroup row">
            <label>제목<span className="redTxt">*</span></label>

            <div className="field full">
              <input type="text" className="input md round_10" name="incruit_title" onChange={(e) => onChange(e)} value={incruit_title} placeholder="제목을 입력해주세요." />
            </div>
          </div>
          
          {/* 내용 [incruit_content] */}
          <div className="fieldGroup row">
            <label>내용<span className="redTxt">*</span></label>

            <div className="field full">
              <DefaultCKEditor
                config={{placeholder: "내용을 입력하세요."}}
                data={incruit_content}
                // onReady={(editor) => {
                //   uploadPlugin(editor, AdIncruitUploadApi, setFileName)
                // }}
                onChange={(event, editor) => {
                  {(incruit_content || incruit_content === "" || curType === "등록") &&
                  setInfo({
                    ...info,
                    incruit_content: editor.getData()
                  })}
                }}
                // onBlur={() => onChangeFile()}
              />
              {/* <textarea type="text" style={{height: '250px'}} className="textarea md round" name="incruit_content" value={incruit_content} onChange={(e) => onChange(e)} placeholder="내용을 입력해주세요." /> */}
            </div>
          </div>

          {/* 작성/수정자 */}
          <div className="fieldGroup row">
            <label>{curType}자</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={userName} disabled />
            </div>
          </div>

          {/* 작성/수정 일시 */}
          <div className="fieldGroup row">
            <label>{curType} 일시</label>

            <div className="field full">
              <input type="text" className="input md round_10" value={curDate} disabled />
            </div>
          </div>
        </fieldset>

        <div className="btnArea">
          {
            userScore >= curScore &&
            <button type="button" className="btn sm sfrtBlue round_10" onClick={() => IncruitConfirm()}>{curType}{master === 1 ? '' : ' 요청'}</button>
          }
          <button type="button" className="btn sm blue_edge round_10" onClick={() => navigate('/admin/dev-employ/incruit/list')}>취소</button>
          {curType === '수정' && userScore >= 300 && <button type="button" className="btn sm red round_10" onClick={() => {if(window.confirm(`정말 해당 게시물을 삭제${master === 1 ? '' : ' 요청'}하시겠습니까?`)) deleteIncruit() }}>{`삭제${master === 1 ? '' : ' 요청'}`}</button>}
        </div>
      </div>
    </>
  )
}

export default AdDevEmployDt;